import React, { useState } from 'react';
import { MailWarning, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE } from '../config';

const VerifyBanner: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.emailVerified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/resend-verification`, {
        method: 'POST',
        credentials: 'include',
      });
      if (res.ok) setSent(true);
    } catch {
      /* ignore — banner stays so the user can retry */
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 px-6 py-2.5 flex items-center justify-between gap-4 text-sm">
      <div className="flex items-center gap-2 text-amber-800 dark:text-amber-300">
        <MailWarning className="w-4 h-4 flex-shrink-0" />
        <span>Verify your email ({user.email}) to enable notifications.</span>
      </div>
      <div className="flex items-center gap-3">
        {sent ? (
          <span className="text-amber-700 dark:text-amber-400">Verification email sent.</span>
        ) : (
          <button
            onClick={resend}
            disabled={sending}
            className="font-medium text-amber-800 dark:text-amber-300 hover:underline disabled:opacity-50"
          >
            {sending ? 'Sending…' : 'Resend email'}
          </button>
        )}
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="text-amber-600 dark:text-amber-500 hover:text-amber-800 dark:hover:text-amber-300"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default VerifyBanner;
